export default __webpack_public_path__ + "static/media/set_2_Link-1.e032d117.svg";